import React, { useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import Conversation from "./Conversation";
import ComposeMsg from "./ComposeMsg";
import { useVisionComments } from "Hooks/vision/useVisionComments";
import { FormProvider } from "react-hook-form";
import {
  myVisionActiveIndex,
  myVisionsForBannerState,
  reloadBanner,
  visionCardsData,
} from "Recoil/Vision/atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getUserId } from "src/utils";
import { get } from "lodash";
import { LoadingWidget } from "Components/index";

const Comments = ({ visionId, isFromBanner, visionCreator }) => {
  const classes = useStyles();
  const { methods, getAllVisionComments, addComment } = useVisionComments();
  const myVisions = useRecoilValue(myVisionsForBannerState);
  const activeIndex = useRecoilValue(myVisionActiveIndex);
  const { setValue, watch, handleSubmit } = methods;
  const visionCards = useRecoilValue(visionCardsData);
  const setVisionCards = useSetRecoilState(visionCardsData);
  const setReloadBanner = useSetRecoilState(reloadBanner);
  const listVision = useRecoilValue(myVisionsForBannerState);

  const setComments = () => {
    const visions = (visionCards || []).map((result) => {
      if (visionId === result.id) {
        return { ...result, totalComments: result.totalComments + 1 };
      }
      return result;
    });
    setVisionCards(visions);
    if (!isFromBanner) {
      (listVision || []).forEach((result) => {
        if (visionId === result.id) {
          setReloadBanner(true);
        }
      });
    }
  };
  const {
    comments,
    parentMessageId,
    commentText,
    createdBy,
    commentLoading,
    loading,
  } = watch();
  useEffect(() => {
    if (visionId) {
      setValue("commentLoading", true);
      const vision = myVisions[activeIndex];
      setValue("visionId", visionId);
      setValue("visionCreator", visionCreator);
      getAllVisionComments({ variables: { visionId } });
    } else {
      setValue("comments", []);
      setValue("loading", false);
    }
  }, [visionId]);

  const fetchData = (newValue, msgId) => {
    let value = [...comments];
    setComments();
    setValue("commentText", "");
    if (msgId == "0") {
      value = [...value, { ...newValue, commentThread: [], createdBy }];
      setValue("loading.parent", false);
    } else {
      const idx = value.findIndex((r) => r.id === msgId);
      if (idx >= 0) {
        const indexValue = value[idx];
        value[idx] = {
          ...indexValue,
          commentThread: [
            ...indexValue.commentThread,
            { ...newValue, createdBy },
          ],
        };
      }
      setValue("loading.child", false);
    }
    setValue("comments", value);
    setValue("parentMessageId", "0");
  };
  const onSubmit = (data) => {
    // setLoader(true);
    const variables = {
      input: {
        visionId: data.visionId,
        responseType: "Comment",
        createdByUserId: getUserId(),
        comment: data.commentText,
        parentMessageId: data.parentMessageId,
      },
    };
    if (data.commentText) {
      if (data.parentMessageId == "0") {
        setValue("loading.parent", true);
      } else {
        setValue("loading.child", true);
      }

      addComment(variables, fetchData);
    }
  };
  const onError = (error) => {
    console.log(error);
  };
  return (
    <FormProvider {...methods}>
      {commentLoading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          width="100%"
        >
          <LoadingWidget color="grey" />
        </Box>
      ) : (
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <Box>
            <Box display="flex" alignItems="center" px={2} pt={2}>
              <Typography variant="subtitle2">Comments</Typography>
              <span className={classes.totalComments}>{comments.length}</span>
            </Box>
            <Conversation />
            <ComposeMsg
              loading={get(loading, "parent", false)}
              commentText={parentMessageId == "0" ? commentText : ""}
            />
          </Box>
        </form>
      )}
    </FormProvider>
  );
};

export default Comments;
